/**
 * this file is managed by "yarn generate-error-code"
 * do not edit manually
 */

export enum ErrorCode {
  e00001 = 'e00001',
  e00002 = 'e00002',
  e00003 = 'e00003',
  e00004 = 'e00004',
  e00005 = 'e00005',
  e00006 = 'e00006',
  e00007 = 'e00007',
  e00008 = 'e00008',
  e00009 = 'e00009',
  e00010 = 'e00010',
  e00011 = 'e00011',
  e00012 = 'e00012',
  e00013 = 'e00013',
  e00014 = 'e00014',
  e00015 = 'e00015',
  e00016 = 'e00016',
  e00017 = 'e00017',
  e00018 = 'e00018',
  e00019 = 'e00019',
  e00020 = 'e00020',
  e00021 = 'e00021',
  e00022 = 'e00022',
  e00023 = 'e00023',
  e00024 = 'e00024',
  e00025 = 'e00025',
  e00026 = 'e00026',
  e00027 = 'e00027',
  e00028 = 'e00028',
  e00029 = 'e00029',
  e00030 = 'e00030',
  e00031 = 'e00031',
  e00032 = 'e00032',
  e00033 = 'e00033',
  e00034 = 'e00034',
  e00035 = 'e00035',
  e00036 = 'e00036',
  e00037 = 'e00037',
  e00038 = 'e00038',
  e00039 = 'e00039',
  e00040 = 'e00040',
  e00041 = 'e00041',
  e00042 = 'e00042',
  e00043 = 'e00043',
  e00044 = 'e00044',
  e00045 = 'e00045',
  e00046 = 'e00046',
  e00047 = 'e00047',
  e00048 = 'e00048',
  e00049 = 'e00049',
  e00050 = 'e00050',
  e00051 = 'e00051',
  e00052 = 'e00052',
  e00053 = 'e00053',
  e00054 = 'e00054',
  e00055 = 'e00055',
  e00056 = 'e00056',
  e00057 = 'e00057',
  e00058 = 'e00058',
  e00059 = 'e00059',
  e00060 = 'e00060',
  e00061 = 'e00061',
  e00062 = 'e00062',
  e00063 = 'e00063',
  e00064 = 'e00064',
  e00065 = 'e00065',
  e00066 = 'e00066',
  e00067 = 'e00067',
  e00068 = 'e00068',
  e00069 = 'e00069',
  e00070 = 'e00070',
  e00071 = 'e00071',
  e00072 = 'e00072',
  e00073 = 'e00073',
  e00074 = 'e00074',
  e00075 = 'e00075',
  e00076 = 'e00076',
  e00077 = 'e00077',
  e00078 = 'e00078',
  e00079 = 'e00079',
  e00080 = 'e00080',
  e00081 = 'e00081',
  e00082 = 'e00082',
  e00083 = 'e00083',
  e00084 = 'e00084',
  e00085 = 'e00085',
  e00086 = 'e00086',
  e00087 = 'e00087',
  e00088 = 'e00088',
  e00089 = 'e00089',
  e00090 = 'e00090',
  e00091 = 'e00091',
  e00092 = 'e00092',
  e00093 = 'e00093',
  e00094 = 'e00094',
  e00095 = 'e00095',
  e00096 = 'e00096',
  e00097 = 'e00097',
  e00098 = 'e00098',
  e00099 = 'e00099',
  e00100 = 'e00100',
  e00101 = 'e00101',
  e00102 = 'e00102',
  e00103 = 'e00103',
  e00104 = 'e00104',
  e00105 = 'e00105',
  e00106 = 'e00106',
  e00107 = 'e00107',
  e00108 = 'e00108',
  e00109 = 'e00109',
  e00110 = 'e00110',
  e00111 = 'e00111',
  e00112 = 'e00112',
  e00113 = 'e00113',
  e00114 = 'e00114',
  e00115 = 'e00115',
  e00116 = 'e00116',
  e00117 = 'e00117',
  e00118 = 'e00118',
  e00119 = 'e00119',
  e00120 = 'e00120',
  e00121 = 'e00121',
  e00122 = 'e00122',
  e00123 = 'e00123',
  e00124 = 'e00124',
  e00125 = 'e00125',
  e00126 = 'e00126',
  e00127 = 'e00127',
  e00128 = 'e00128',
  e00129 = 'e00129',
  e00130 = 'e00130',
  e00131 = 'e00131',
  e00132 = 'e00132',
  e00133 = 'e00133',
  e00134 = 'e00134',
  e00135 = 'e00135',
  e00136 = 'e00136',
  e00137 = 'e00137',
  e00138 = 'e00138',
  e00139 = 'e00139',
  e00140 = 'e00140',
  e00141 = 'e00141',
  e00142 = 'e00142',
  e00143 = 'e00143',
  e00144 = 'e00144',
  e00145 = 'e00145',
  e00146 = 'e00146',
  e00147 = 'e00147',
  e00148 = 'e00148',
  e00149 = 'e00149',
  e00150 = 'e00150',
  e00151 = 'e00151',
  e00152 = 'e00152',
  e00153 = 'e00153',
  e00154 = 'e00154',
  e00155 = 'e00155',
  e00156 = 'e00156',
  e00157 = 'e00157',
  e00158 = 'e00158',
  e00159 = 'e00159',
  e00160 = 'e00160',
  e00161 = 'e00161',
  e00162 = 'e00162',
  e00163 = 'e00163',
  e00164 = 'e00164',
  e00165 = 'e00165',
  e00166 = 'e00166',
  e00167 = 'e00167',
  e00168 = 'e00168',
  e00169 = 'e00169',
  e00170 = 'e00170',
  e00171 = 'e00171',
  e00172 = 'e00172',
  e00173 = 'e00173',
  e00174 = 'e00174',
  e00175 = 'e00175',
  e00176 = 'e00176',
  e00177 = 'e00177',
  e00178 = 'e00178',
  e00179 = 'e00179',
  e00180 = 'e00180',
  e00181 = 'e00181',
  e00182 = 'e00182',
  e00183 = 'e00183',
  e00184 = 'e00184',
  e00185 = 'e00185',
  e00186 = 'e00186',
  e00187 = 'e00187',
  e00188 = 'e00188',
  e00189 = 'e00189',
  e00190 = 'e00190',
  e00191 = 'e00191',
  e00192 = 'e00192',
  e00193 = 'e00193',
  e00194 = 'e00194',
  e00195 = 'e00195',
  e00196 = 'e00196',
  e00197 = 'e00197',
  e00198 = 'e00198',
  e00199 = 'e00199',
  e00200 = 'e00200',
  e00201 = 'e00201',
  e00202 = 'e00202',
  e00203 = 'e00203',
  e00204 = 'e00204',
  e00205 = 'e00205',
  e00206 = 'e00206',
  e00207 = 'e00207',
  e00208 = 'e00208',
  e00209 = 'e00209',
  e00210 = 'e00210',
  e00211 = 'e00211',
  e00212 = 'e00212',
  e00213 = 'e00213',
  e00214 = 'e00214',
  e00215 = 'e00215',
  e00216 = 'e00216',
  e00217 = 'e00217',
  e00218 = 'e00218',
  e00219 = 'e00219',
  e00220 = 'e00220',
  e00221 = 'e00221',
  e00222 = 'e00222',
  e00223 = 'e00223',
  e00224 = 'e00224',
  e00225 = 'e00225',
  e00226 = 'e00226',
  e00227 = 'e00227',
  e00228 = 'e00228',
  e00229 = 'e00229',
  e00230 = 'e00230',
  e00231 = 'e00231',
  e00232 = 'e00232',
  e00233 = 'e00233',
  e00234 = 'e00234',
  e00235 = 'e00235',
  e00236 = 'e00236',
  e00237 = 'e00237',
  e00238 = 'e00238',
  e00239 = 'e00239',
  e00240 = 'e00240',
  e00241 = 'e00241',
  e00242 = 'e00242',
  e00243 = 'e00243',
  e00244 = 'e00244',
  e00245 = 'e00245',
  e00246 = 'e00246',
  e00247 = 'e00247',
  e00248 = 'e00248',
  e00249 = 'e00249',
  e00250 = 'e00250',
  e00251 = 'e00251',
  e00252 = 'e00252',
  e00253 = 'e00253',
  e00254 = 'e00254',
  e00255 = 'e00255',
  e00256 = 'e00256',
  e00257 = 'e00257',
  e00258 = 'e00258',
  e00259 = 'e00259',
  e00260 = 'e00260',
  e00261 = 'e00261',
  e00262 = 'e00262',
  e00263 = 'e00263',
  e00264 = 'e00264',
  e00265 = 'e00265',
  e00266 = 'e00266',
  e00267 = 'e00267',
  e00268 = 'e00268',
  e00269 = 'e00269',
  e00270 = 'e00270',
  e00271 = 'e00271',
  e00272 = 'e00272',
  e00273 = 'e00273',
  e00274 = 'e00274',
  e00275 = 'e00275',
  e00276 = 'e00276',
  e00277 = 'e00277',
  e00278 = 'e00278',
  e00279 = 'e00279',
  e00280 = 'e00280',
  e00281 = 'e00281',
  e00282 = 'e00282',
  e00283 = 'e00283',
    e00284 = "e00284",
    e00285 = "e00285",
    e00286 = "e00286",
    e00287 = "e00287",
    e00288 = "e00288",
    e00289 = "e00289",
    e00290 = "e00290",
    e00291 = "e00291",
    e00292 = "e00292",
    e00293 = "e00293",
    e00294 = "e00294",
    e00295 = "e00295",
    e00296 = "e00296",
    e00297 = "e00297",
    e00298 = "e00298",
    e00299 = "e00299",
    e00300 = "e00300",
    e00301 = "e00301",
    e00302 = "e00302",
    e00303 = "e00303",
    e00304 = "e00304",
    e00305 = "e00305",
    e00306 = "e00306",
    e00307 = "e00307",
    e00308 = "e00308",
    e00309 = "e00309",
    e00310 = "e00310",
    e00311 = "e00311",
    e00312 = "e00312",
    e00313 = "e00313",
    e00314 = "e00314",
    e00315 = "e00315",
    e00316 = "e00316",
    e00317 = "e00317",
    e00318 = "e00318",
    e00319 = "e00319",
    e00320 = "e00320",
    e00321 = "e00321"
}
